import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import '@/App.css';
import Login from '@/pages/Login.jsx';
import Dashboard from '@/pages/Dashboard.jsx';
import CandidateDetail from '@/pages/CandidateDetail.jsx';
import AssessmentInvite from '@/pages/AssessmentInvite.jsx';
import Assessment from '@/pages/Assessment.jsx';
import AssessmentComplete from '@/pages/AssessmentComplete.jsx';
import AdminQuestions from '@/pages/AdminQuestions.jsx';
import AssessmentManager from '@/pages/AssessmentManager.jsx';
import AssessmentQuestions from '@/pages/AssessmentQuestions.jsx';
import SectorManager from '@/pages/SectorManager.jsx';
import PublicRegistration from '@/pages/PublicRegistration.jsx';
import EvaluationManager from '@/pages/EvaluationManager.jsx';
import { Toaster } from '@/components/ui/sonner';

import SSOHandler from './SSOHandler';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user') || 'null'));
  
  const handleLogin = (newToken, userData) => {
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(userData));
    setToken(newToken);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  return (
    <BrowserRouter>
      <div className="App">
        <SSOHandler onLogin={handleLogin} />
        <Routes>
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          
          {/* Public Routes - No Authentication Required */}
          <Route path="/public/register/:publicLink" element={<PublicRegistration />} />
          <Route path="/avaliacao/:token" element={<AssessmentInvite />} />
          <Route path="/avaliacao/:token/iniciar" element={<Assessment />} />
          <Route path="/avaliacao/:token/completo" element={<AssessmentComplete />} />
          
          {/* Protected Routes */}
          <Route path="/dashboard" element={token ? <Dashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/candidatos/:id" element={token ? <CandidateDetail user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/admin/perguntas" element={token ? <AdminQuestions user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/assessments" element={token ? <AssessmentManager user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/assessments/:assessmentId/questions" element={token ? <AssessmentQuestions user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/sectors" element={token ? <SectorManager user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/evaluations" element={token ? <EvaluationManager user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          
          <Route path="/" element={token ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;




